export default __webpack_public_path__ + "static/kathi_finall-c033431318bf9545e63cb644831db8ba.png";